import type { CoreState, PluginCommunication, ResourcesService } from "@/client/core/Core.api";
import type {
    LabsAudioResource,
    LabsJsonResource,
    LabsMidiResource,
    LabsResourceID,
} from "@/client/core/platform-types/labs.api";
import {
    filterAudioResource,
    filterJsonResource,
    filterMidiResource,
} from "@/client/utils/filterResources";

export const createResourcesServiceForPlugin = (
    state: CoreState,
    communication: PluginCommunication,
): ResourcesService => ({
    addFiles: communication.addFiles,
    requestAllResources: communication.getAllResources,
    deleteResources: communication.deleteResources,
    revealOnDisk: communication.revealResourceOnDisk,
    updateResourceMetadata: (id, update) => {
        const resource = state.resources.get(id.value);
        if (resource === undefined) {
            return Promise.resolve();
        }
        return communication.updateResourceMetadata(id, {
            ...resource.metadata,
            ...update,
        });
    },
    getAudioResource(id: LabsResourceID): LabsAudioResource | undefined {
        return filterAudioResource(id, state.resources);
    },
    getMidiResource(id: LabsResourceID): LabsMidiResource | undefined {
        return filterMidiResource(id, state.resources);
    },
    getJsonResource(id: LabsResourceID): LabsJsonResource | undefined {
        return filterJsonResource(id, state.resources);
    },
});
